/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RefDisplayType {
    CARD = 'card',
    DROPDOWN = 'dropdown',
}
